export const API_TOKEN = "snd0itdoy4bpiuehtuskqnadau07nuzm";
export const CAPTCH_CLIENT_KEY: string =
  "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
  export const FLOWBOX_CHECKOUT_API_KEY = "1306c7f0bb6921ac742e29ad07e834d3";
  export const FLOWBOX_HOME_PAGE_FLOW_KEY = "g3l5TJGFSBeJldTY5Xjv6w";
  export const FLOWBOX_PRODUCT_DETAILS_PAGE_FLOW_KEY = "iAj-mHVSTGeAmvEWb-Hzcg";
  export const FLOWBOX_CATEGORY_PAGE_FLOW_KEY = "ZR7LfmpFQsCMSGNp4nPuDQ";
  export const FLOWBOX_COMMUNITY_PAGE_FLOW_KEY = "zoIVCqnqQlWpJ1lLk1fDoQ";